module.exports = __webpack_public_path__ + "static/icons/icon-tide-needle-6f21dad5a6a6957bef4a35fcebea6670.svg";